import { Card as MantineCard, CardProps } from '@mantine/core';

export type ICardProps = CardProps;

/** @registry Design-layer pass-through over Mantine Card; import this instead of @mantine/core Card outside src/design. Compound statics (Card.Section) are preserved. */
export const Card = MantineCard;
